import { createElement } from 'react';
import { useDesignTokens, renderInlineCssVars } from '../../../theme';
import { Label } from '../../Label';
import { TestIdProps } from '../../../util/testId';
import { useNCTextLocalizer } from '../../../locale/useNCTextLocalizer';

import cx from 'classnames';
import cn from './FocusPreview.css.json';
import './FocusPreview.css';

export interface FocusPreviewProps extends TestIdProps {
  id?: string;
  color?: string;
  thickness?: number;
  opacity?: number;
  disabled?: boolean;
}

export const FocusPreview = (props: FocusPreviewProps) => {
  const localize = useNCTextLocalizer('Settings');
  const opacity = ((props.opacity ?? 100) / 100) * (props.disabled ? 0.3 : 1);
  const thickness = props.thickness ?? 1;
  const color = props.color ? props.color : '#000000';

  const borderStyle = { border: `${thickness}px dotted ${getRGBString(color, opacity)}` };

  const dt = useDesignTokens();
  const tokens = renderInlineCssVars(
    {
      'spacing-m': dt.spacing.core.m,
      'spacing-xs': dt.spacing.core.xs,
    },
    'focus-preview'
  );

  return (
    <div style={tokens} className={cx(cn.outerBox, props.disabled && cn.disabled)}>
      <div style={borderStyle} className={cn.maskBox}>
        <Label className={cn.maskLabel} disabled={props.disabled}>
          {localize('settings.focusPreview.itemInFocus.label')}
        </Label>
      </div>
      <Label disabled={props.disabled}>
        {localize('settings.focusPreview.adjacentItem.label')}
      </Label>
    </div>
  );
};

const getRGBString = (hex: string, opacity: number) => {
  hex = hex.substring(1, hex.length);
  if (hex.length === 3) {
    hex =
      hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
  }
  const red = parseInt(hex.substr(0, 2), 16);
  const green = parseInt(hex.substr(2, 2), 16);
  const blue = parseInt(hex.substr(4, 2), 16);

  return `rgba(${red},${green},${blue},${opacity})`;
};
